import React, { useState, useRef, useCallback, useEffect } from 'react';
import { isMobileSafari } from 'react-device-detect';
import Slider from 'react-slick';
import { Box, makeStyles } from '@material-ui/core';
import { KeyboardArrowRight, KeyboardArrowLeft, Close } from '@material-ui/icons';


const useStyles = makeStyles((theme) => {
  return {
    gallery_preview: {
      position: 'fixed',
      top: '0',
      right: '0',
      bottom: '0',
      left: '0',
      background: 'rgba(0, 0, 0, .9)',
      zIndex: '9999',
      '& .slick-slide': { height: 'auto' },
      '& .slick-slider': { height: '100%' },
      '& .slick-slider .slick-list': { height: '100%' },
      '& .slick-slider .slick-list .slick-track': {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100%',
      },
      '& .slick-slide > div': { textAlign: 'center' },
      '& .slick-slide > div > div': { outline: 'none' },
      '& .slick-slide img': {
        objectFit: 'contain',
        margin: '0 auto',
        maxHeight: '100vh',
        maxWidth: '100vw',
        [theme.breakpoints.down('sm')]: { width: '100%' },
      },
    },
    close_icon: {
      position: 'absolute',
      top: '10px',
      right: '20px',
      color: theme.palette.common.white,
      fontSize: '30px',
      cursor: 'pointer',
      zIndex: '10',
    },
    gallery_preview_content: {
      position: 'relative',
      width: '100%',
      height: '100%',
    },
    next_arrow: {
      position: 'absolute',
      top: '50%',
      right: '10px',
      transform: 'translateY(-50%)',
      fontSize: '38px',
      color: theme.palette.common.white,
      zIndex: '1',
      cursor: 'pointer',
    },
    previous_arrow: {
      position: 'absolute',
      top: '50%',
      left: '10px',
      transform: 'translateY(-50%)',
      fontSize: '38px',
      color: theme.palette.common.white,
      zIndex: '1',
      cursor: 'pointer',
    },
  };
});

const GalleryPreviewChat = ({ images, onClose, loadImage }) => {
  const classes = useStyles();

  const imagePreviewContentRef = useRef();
  const sliderRef = useRef();

  const imagePreviewContentKeyDownHandler = useCallback((event) => {
    switch (event.keyCode) {
      case 27:
        onClose(false);
        break;
      case 39:
        sliderRef.current.slickNext();
        break;
      case 37:
        sliderRef.current.slickPrev();
        break;
      default:
        break;
    }
  }, [onClose]);

  const imagePreviewContentClickHandler = useCallback((event) => {
    const { target } = event.nativeEvent;
    if (target.tagName === 'DIV') {
      onClose();
    }
  }, [onClose]);

  return (
    <Box className={classes.gallery_preview}>
      <Box
        className={classes.close_icon}
        onClick={onClose}
      >
        <Close fontSize="inherit" />
      </Box>
      <Box
        ref={imagePreviewContentRef}
        className={classes.gallery_preview_content}
        tabIndex={0}
        onClick={imagePreviewContentClickHandler}
        onKeyDown={imagePreviewContentKeyDownHandler}
      >
        <Slider
          ref={sliderRef}
          autoplay={false}
          dots={false}
          lazyLoad={true}
          nextArrow={<NextArrow />}
          prevArrow={<PreviousArrow />}
        >
          {images.map((image) => (
            <img key={image.id} alt="" loading="lazy" src={image.url} />
          ))}
        </Slider>
      </Box>
    </Box>
  );
};

const NextArrow = ({ onClick }) => {
  const classes = useStyles();

  return (
    <KeyboardArrowRight
      className={classes.next_arrow}
      onClick={onClick}
    />
  );
};

const PreviousArrow = ({ onClick }) => {
  const classes = useStyles();

  return (
    <KeyboardArrowLeft
      className={classes.previous_arrow}
      onClick={onClick}
    />
  );
};

export default GalleryPreviewChat;
